export default __webpack_public_path__ + "static/media/estate-forms-icon.68e7382a.svg";